import { render, staticRenderFns } from "./PurchasingPie.vue?vue&type=template&id=633ebeca&scoped=true&"
import script from "./PurchasingPie.vue?vue&type=script&lang=js&"
export * from "./PurchasingPie.vue?vue&type=script&lang=js&"
import style0 from "./PurchasingPie.vue?vue&type=style&index=0&id=633ebeca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "633ebeca",
  null
  
)

export default component.exports